import type { PayAndStoreStatus } from '../../services/payment/types';

const isAuthRequiredForPayment = (status: PayAndStoreStatus) =>
  status === 'AUTH_REQUIRED';

export default isAuthRequiredForPayment;
